import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentTheme: localStorage.getItem('theme') || 'pokeball'
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setTheme: (state, action) => {
      state.currentTheme = action.payload;
      localStorage.setItem('theme', action.payload);
    }
  }
});

export const { setTheme } = themeSlice.actions;
export const selectTheme = (state) => state.theme.currentTheme;
export default themeSlice.reducer; 